import { Box, Flex, Button, VStack } from "@chakra-ui/react";
import { RxReset } from "react-icons/rx";
import { useChatStore } from "../store/chat.store";
import UserMessage from "@/components/chat/UserMessage";
import AssistantMessage from "@/components/chat/AssistantMessage";
import { TypingIndicator } from "@/components/common/TypingIndicator";

const Chat: React.FC = () => {
  const { messages, loading, reset } = useChatStore();

  if (messages.length === 0) return null;

  return (
    <Box w="100%" borderRadius={20} p={5} position="relative">
      <VStack spacing={3}>
        {!loading && (
          <Flex justify="flex-end" w="100%">
            <Button
              variant="ghost"
              size="sm"
              color="#667085"
              onClick={reset}
              leftIcon={<RxReset size={20} />}
            >
              Volver
            </Button>
          </Flex>
        )}

        {messages.map((msg) =>
          msg.role === "user" ? (
            <UserMessage key={msg.id} text={msg.text} />
          ) : (
            <AssistantMessage key={msg.id} text={msg.text} />
          ),
        )}
      </VStack>

      {loading && (
        <Flex
          position="absolute"
          bottom="16px"
          left="16px"
          bg="white"
          px={4}
          py={2}
          borderRadius="16px"
          boxShadow="md"
        >
          <TypingIndicator />
        </Flex>
      )}
    </Box>
  );
};

export default Chat;
